const initialState = {
	frequency: [],
	gdrivedocs: [],
	isLoading: false,
	folderName: '',
	id: 0,
	frequencyName : ''
}

const sharedFolderCMReducer = (state = initialState, action) => {
	switch (action.type) {
		case "getdataforgdrivefrequency":
			state = { ...state, frequency: action.payload }
			return state;
		case "getgdrivedocs":
			state = { ...state, gdrivedocs: action.payload }
			return state;
		case "isloadingsharedcmdata":
			state = { ...state, isLoading: action.payload }
			return state;
		case "getFolderName":
			state = { ...state, folderName: action.payload }
			return state;
		case "getFolderId":
			state = { ...state, id: action.payload }
			return state;
			case "getFrequencyName":
				state = { ...state, frequencyName: action.payload }
				return state;
		default:
			return state;
	}
}

export default sharedFolderCMReducer;